/* Découpe la description produit en sections dépliables.
   Les 5 titres connus (Composition et détails / Expédition / Guide des tailles /
   Entretien / Création et confection) sont cherchés dans le TEXTE lui-même :
   peu importe le gras/italique, les accents, les caractères invisibles, ou
   qu'un titre soit collé en milieu de ligne (ex : « XL= 1m95<Entretien: »).
   Pour éviter les faux positifs (« Préparation et expédition sous 72 h »),
   un titre n'est reconnu que s'il est suivi de « : » ou seul sur sa ligne.
   Une ligne courte inconnue finissant par « : » devient aussi une section. */
(function () {
  var KNOWN = [
    'composition et details',
    'guide des tailles',
    'creation et confection',
    'expedition',
    'entretien'
  ];
  var LABELS = {
    'composition et details': 'Composition et détails',
    'guide des tailles': 'Guide des tailles',
    'creation et confection': 'Création et confection',
    'expedition': 'Expédition',
    'entretien': 'Entretien'
  };
  var GENERIC_MAX = 45;

  var COMBINING = /[̀-ͯ]/g; /* accents décomposés (NFD) */
  var INVISIBLE = /[​-‍﻿⁠]/g; /* caractères de largeur nulle */
  var BLANKISH = /[\s ​-‍﻿⁠]+/g;
  var LEADING_JUNK_COLON = /^[\s ​-‍﻿⁠]*[:：]?/;
  var STARTS_WITH_COLON = /^[\s ​-‍﻿⁠]*[:：]/;
  var ENDS_WITH_COLON = /[:：]$/;

  /* Chaîne normalisée (minuscules, sans accents ni caractères invisibles,
     espaces réduits) + table de correspondance vers les index d'origine. */
  function buildNorm(str) {
    var norm = '';
    var map = [];
    for (var i = 0; i < str.length; i++) {
      var d = str[i]
        .normalize('NFD')
        .replace(COMBINING, '')
        .replace(INVISIBLE, '')
        .replace(/[\s ]/g, ' ')
        .toLowerCase();
      for (var j = 0; j < d.length; j++) {
        if (d[j] === ' ' && norm.slice(-1) === ' ') continue;
        norm += d[j];
        map.push(i);
      }
    }
    return { norm: norm, map: map };
  }

  function isBlankText(str) {
    return str.replace(BLANKISH, '') === '';
  }

  function cleanText(str) {
    return str.replace(INVISIBLE, '').replace(/[\s ]+/g, ' ').trim();
  }

  /* Aplatit la description en lignes de texte (coupées aux <br> et aux blocs). */
  function textLines(desc) {
    var lines = [];
    var buf = '';
    function push() {
      if (!isBlankText(buf)) lines.push(buf);
      buf = '';
    }
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          buf += child.textContent;
          return;
        }
        if (child.nodeType !== 1) return;
        var tag = child.tagName;
        if (tag === 'BR') {
          push();
        } else if (/^(P|DIV|UL|OL|LI|H[1-6]|SECTION|ARTICLE|TABLE|TR|BLOCKQUOTE)$/.test(tag)) {
          push();
          walk(child);
          push();
        } else {
          buf += child.textContent;
        }
      });
    })(desc);
    push();
    return lines;
  }

  /* Découpe une ligne en morceaux { heading } / { text }. */
  function splitParts(line) {
    var parts = [];
    var remaining = line;
    var guard = 0;

    while (remaining && guard++ < 20) {
      var b = buildNorm(remaining);
      var best = null;

      KNOWN.forEach(function (key) {
        var from = 0;
        while (true) {
          var idx = b.norm.indexOf(key, from);
          if (idx === -1) break;
          var startOrig = b.map[idx];
          var endNorm = idx + key.length;
          var endOrig = endNorm < b.map.length ? b.map[endNorm] : remaining.length;
          var after = remaining.slice(endOrig);
          var followedByColon = STARTS_WITH_COLON.test(after);
          var aloneOnLine = idx === 0 && isBlankText(after);
          if (followedByColon || aloneOnLine) {
            if (best === null || idx < best.idx) {
              best = { idx: idx, key: key, startOrig: startOrig, endOrig: endOrig };
            }
            break;
          }
          from = idx + 1;
        }
      });

      if (!best) break;

      var before = remaining.slice(0, best.startOrig);
      if (!isBlankText(before)) parts.push({ heading: null, text: before });
      parts.push({ heading: LABELS[best.key] });
      remaining = remaining.slice(best.endOrig).replace(LEADING_JUNK_COLON, '');
    }

    if (remaining && !isBlankText(remaining)) {
      var t = cleanText(remaining);
      if (parts.length === 0 && t.length <= GENERIC_MAX && ENDS_WITH_COLON.test(t)) {
        parts.push({ heading: t.replace(/\s*[:：]$/, '') });
      } else {
        parts.push({ heading: null, text: remaining });
      }
    }
    return parts;
  }

  function fillContent(container, texts) {
    texts.forEach(function (text, idx) {
      if (idx > 0) container.appendChild(document.createElement('br'));
      container.appendChild(document.createTextNode(cleanText(text)));
    });
  }

  function init() {
    document.querySelectorAll('[data-aplb-accordion]').forEach(function (desc) {
      if (desc.dataset.aplbDone) return;
      desc.dataset.aplbDone = 'true';

      var preamble = [];
      var groups = [];
      var current = null;

      textLines(desc).forEach(function (line) {
        splitParts(line).forEach(function (part) {
          if (part.heading != null) {
            current = { title: part.heading, texts: [] };
            groups.push(current);
          } else if (current) {
            current.texts.push(part.text);
          } else {
            preamble.push(part.text);
          }
        });
      });

      if (!groups.length) return;

      var frag = document.createDocumentFragment();

      if (preamble.length) {
        var intro = document.createElement('div');
        intro.className = 'aplb-acc__intro rte';
        fillContent(intro, preamble);
        frag.appendChild(intro);
      }

      var first = true;
      groups.forEach(function (g) {
        var details = document.createElement('details');
        details.className = 'aplb-acc';
        if (first) {
          first = false;
          details.open = true;
        }

        var summary = document.createElement('summary');
        summary.className = 'aplb-acc__summary';
        var label = document.createElement('span');
        label.className = 'aplb-acc__title';
        label.textContent = g.title;
        var icon = document.createElement('span');
        icon.className = 'aplb-acc__icon';
        icon.setAttribute('aria-hidden', 'true');
        summary.appendChild(label);
        summary.appendChild(icon);
        details.appendChild(summary);

        var content = document.createElement('div');
        content.className = 'aplb-acc__content';
        fillContent(content, g.texts);
        details.appendChild(content);

        frag.appendChild(details);
      });

      desc.innerHTML = '';
      desc.appendChild(frag);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
